"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetKey = void 0;
const tslib_1 = require("tslib");
const t = (0, tslib_1.__importStar)(require("io-ts"));
const function_1 = require("../validators/function");
const widgetKeyRegex = new RegExp("^[^<>]+$");
exports.WidgetKey = (0, function_1.refineType)(t.string, "WidgetKey", (s) => s.length === 0 || widgetKeyRegex.test(s));
